import { useMemo } from "react";
import { useApi } from "src/hooks/useApi";
import type { GoaCode } from "src/helpers/goaRules";

/** The full GOÄ catalog as a list (for search) and by Ziffer (for lookups). Cached by useApi.
 *  `enabled: false` skips loading it. */
export function useGoaCatalog(enabled = true) {
    const { data } = useApi<{ codes: GoaCode[] }>(enabled ? "/goa/catalog?scope=all" : null);
    const catalogList = useMemo(() => data?.codes ?? [], [data]);
    const catalogByNr = useMemo(() => {
        const map = new Map<string, GoaCode>();
        for (const c of catalogList) map.set(c.nr, c);
        return map;
    }, [catalogList]);
    return { catalogList, catalogByNr };
}
